import gql from 'graphql-tag';
import { useQuery, type ApolloError } from '@apollo/react-hooks';

const GET_DRC_HOME_PAGE_COUNT = gql`
  query (
    $toDoFilter: NominationFilter
    $allApplicationFilter: NominationFilter
    $ApplicationFilter: ApplicationFilter
    $conditionsFilter: OfferedApplicationFilter!
  ) {
    toDoApplications: nominationsPaginated(filter: $toDoFilter) {
      paginator {
        count
      }
    }

    allApplications: nominationsPaginated(filter: $allApplicationFilter) {
      paginator {
        count
      }
    }

    applicationsPaginated(filter: $ApplicationFilter) {
      paginator {
        count
      }
    }

    meetConditionList(filter: $conditionsFilter) {
      paginator {
        count
      }
    }
  }
`;

export type GetDRCHomePageCount = {
  count: {
    toDoApplications: number;
    allApplication: number;
    nonProposedApplications: number;
    conditions: number;
  };
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDRCHomePageCount = (
  toDoFilter: any,
  allApplicationFilter: any,
  nonProposedFilter: any,
  conditionsFilter: any,
): GetDRCHomePageCount => {
  const { data, loading, error } = useQuery(GET_DRC_HOME_PAGE_COUNT, {
    variables: {
      toDoFilter,
      allApplicationFilter,
      ApplicationFilter: nonProposedFilter,
      conditionsFilter,
    },
  });

  const count = {
    toDoApplications: data?.toDoApplications.paginator.count ?? 0,
    allApplication: data?.allApplications.paginator.count ?? 0,
    nonProposedApplications: data?.applicationsPaginated.paginator.count ?? 0,
    conditions: data?.meetConditionList.paginator.count ?? 0,
  };

  return { count, loading, error };
};
